/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ContactTypes } from "@src/app/model/person";
import { TableView } from "@src/app/model/sys/nav-item";
import { PersonPageComponent } from "@src/app/pages/person-page/person-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const PersonPageNavRoute = new NavRoute('people', ()=>PersonPageComponent, 'people').setViews(() => {
    const views = [
        {
            id: 'allContact',
            name: 'All Contacts',
            filterFields: {
                contactType: null,
                entityType: null,
                lastName: null,
                firstName: null,
                keyword: null,
            },
            sort: 'createdAt',
            helpText: $localize `All contacts within the OMC`
        } as TableView,
        {
            id: 'currentMembers',
            name: 'Current Members',
            filterFields: {
                contactType: null,
                entityType: null,
                lastName: null,
                firstName: null,
                keyword: null,
                currentMember: 1,
            },
            sort: 'createdAt',
            helpText: $localize `Contacts who are currently members of the OMC`
        } as TableView        
    ];
    ContactTypes.omcSelectables().forEach( ct => {
        views.push({
            id: ct.id as string,
            name: ct.name,
            filterFields: {
                contactType: ct.id as string
            },
            helpText: ct.notes as string,
        })
    })
    return views;
});